import type { Metric } from '@atlassian/browser-metrics/metric';

import { createConcurrentCustomMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { LEGACY_EXTENSION_LOADING_CUSTOM_KEY } from '@confluence/browser-metrics/entry-points/metric-keys/customKey.ts';

export const LEGACY_EXTENSION_LOADING_METRIC: (concurrentId: string | number) => Metric =
	createConcurrentCustomMetric({
		key: LEGACY_EXTENSION_LOADING_CUSTOM_KEY,
	});
